import type { ApiClient } from "@/clients/ApiClient";

export interface ToplistApi {
    /** The chart for a day (YYYY-MM-DD), or the latest one without a day */
    chart(day?: string): Promise<ToplistResponse>;
}

// Both APIs answer with the page itself: PHP as the whole body (with `cached` in it), Go as the
// envelope's data (with `cached` on the envelope), so there is nothing to unwrap here.
export const createToplistApi = (client: ApiClient): ToplistApi => ({
    async chart(day) {
        const page = await client.get<Partial<ToplistResponse>>(
            day ? `/podcasts/toplist?date=${encodeURIComponent(day)}` : "/podcasts/toplist"
        );
        return {
            date: "",
            count: 0,
            latest: false,
            previous: null,
            next: null,
            ...page,
            cached: page.cached ?? false,
            toplist: page.toplist ?? [],
        };
    },
});
